/* eslint-disable import/prefer-default-export */
export const IOICategoryArray = ['6675385baa5909ba52c242ca'];
